import { createSlice } from '@reduxjs/toolkit';
import { contentType } from './types.ts';
import { fetchContent } from '../api/fetchSiteContent.ts';

interface ContentState {
  data: contentType | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: ContentState = {
  data: null,
  isLoading: false,
  error: null,
};

const contentSlice = createSlice({
  name: 'content',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContent.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchContent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchContent.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Неизвестная ошибка';
      });
  },
});

export default contentSlice.reducer;
